module.exports = __webpack_public_path__ + "img/advantages2.81d8b95b.jpg";